import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { IEntityResolver } from '@kpd/framework-ngx';
import { Role } from 'app/shared/models/role';
import { RoleService } from 'app/shared/services/role.service';
import { RoleKey } from 'app/shared/models/keys/role-key';

@Injectable()
export class RoleEntityResolver implements IEntityResolver<Role> {
  constructor(private roleService: RoleService) {}

  resolve(params: { name: string; application: string }): Observable<Role> {
    if (params.name === '0') {
      return of(new Role());
    }
    const key = RoleKey.composeKeyByRouteParams(params);
    return this.roleService.getById(key);
  }
}
